import { keyframes } from "@emotion/react";
import { Box, type BoxProps, Row } from "@hightouch/htui";

const duration = 1.5;
const size = 8;

const dot = keyframes`
  0% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
`;

type LoadingDotsProps = {
  /** Dot fill color. Defaults to primary; pass `white` on primary buttons. */
  color?: BoxProps["bg"];
};

export const LoadingDots = ({ color = "primary.base" }: LoadingDotsProps) => {
  const sharedStyles: BoxProps = {
    height: `${size}px`,
    width: `${size}px`,
    borderRadius: "lg",
    bg: color,
    animation: `${dot} ${duration}s ease-in infinite`,
  };

  return (
    <Row gap={1}>
      <Box {...sharedStyles} />
      <Box
        {...sharedStyles}
        sx={{
          animationDelay: `${duration / 4}s`,
        }}
      />
      <Box
        {...sharedStyles}
        sx={{
          animationDelay: `${duration / 2}s`,
        }}
      />
    </Row>
  );
};
